import { Box, Skeleton } from '@mui/material';

export const FsDialogBody = ({ loading = false, className = '', children }) => {
	return (
		<Box className={`fs-dialog-body ${className}`}>
			{!loading ? (
				children
			) : (
				<Box className="grid grid-flow-row gap-4">
					<Skeleton variant="text" sx={{ fontSize: '2rem', width: '100%' }} />
					<Skeleton variant="text" sx={{ fontSize: '2rem', width: '100%' }} />
					<Skeleton variant="text" sx={{ fontSize: '2rem', width: '100%' }} />
				</Box>
			)}
		</Box>
	);
};
